/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../renderSequence/api/RenderStepProviderAPI',
	'./api/QueryResultOverrideAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], function(RenderStepProviderAPI, QueryResultOverrideAPI, APIFactory) {

	class QueryResultOverride {

		/**
		 * @param {Object} options
		 * @param {ContentAPI} options.content
		 */
		constructor(options) {
			this._content = options.content;
			this._api = APIFactory.createAPI(this, [RenderStepProviderAPI, QueryResultOverrideAPI]);
		}

		initialize() {
			this._content.getFeature('RenderSequence').registerRenderStepProvider(this.getAPI());
		}

		getAPI() {
			return this._api;
		}

		destroy() {
			this._content = null;
		}

		/**
		 * @implements QueryResultOverrideAPI.setQueryResults
		 */
		setQueryResults(queryResults) {
			this._queryResults = queryResults;
		}

		/**
		 * @implements RenderStepProviderAPI.getRenderStepList
		 */
		getRenderStepList() {
			return [{
				id: 'data',
				dependencies: ['predictSuggestions', 'keyDrivers'],
				modulePath: 'dashboard-analytics/features/widget/queryResultOverride/DataTaskOverride',
				moduleOptions: {
					queryResults: this._queryResults
				}
			}];
		}
	}

	return QueryResultOverride;
});
